import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import NcDmvDrivewayPermitsDetails from './NcDmvDrivewayPermitsDetails';

const NcDmvDrivewayPermitsModal = ({ selectedDrivewayPermit, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant="primary" onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Permit Number: {selectedDrivewayPermit.externalAccountId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            return show
              ? <NcDmvDrivewayPermitsDetails selectedDrivewayPermit={selectedDrivewayPermit} />
              : undefined;
          })()}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

export default NcDmvDrivewayPermitsModal;

NcDmvDrivewayPermitsModal.propTypes = {
  selectedDrivewayPermit: PropTypes.instanceOf(Object).isRequired,
};
